var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.userData === undefined ? 'div' : 'b-card',{tag:"component",staticClass:"user-profile"},[_c('agent-timings',{attrs:{"readonly":true,"agent-timings":_vm.agentTimings}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }